export const STORES_PAGE_SIZE = 10;
